import axiosInstance from "./api_helper";

const lotService = {
  // Lister les lots avec pagination et filtres
  list: async (params) => {
    const response = await axiosInstance.get('/api/lots', { params });
    return response.data;
  },

  // Créer un nouveau lot
  create: async (lotData) => {
    const response = await axiosInstance.post('/api/lots', lotData);
    return response.data;
  },

  // Mettre à jour un lot
  update: async (numeroLot, lotData) => {
    const response = await axiosInstance.put(`/api/lots/${numeroLot}`, lotData);
    return response.data;
  },

  // Supprimer un lot
  delete: async (numeroLot) => {
    const response = await axiosInstance.delete(`/api/lots/${numeroLot}`);
    return response.data;
  },

  // Obtenir les détails d'un lot
  getByNumero: async (numeroLot) => {
    const response = await axiosInstance.get(`/api/lots/${numeroLot}`);
    return response.data;
  },

  // Changer le statut d'un lot
  changeStatut: async (numeroLot, statut) => {
    const response = await axiosInstance.patch(`/api/lots/${numeroLot}/statut`, { statut });
    return response.data;
  },

  // Générer un numéro de lot automatique
  generateNumeroLot: async (articleId) => {
    const response = await axiosInstance.post('/api/lots/generate-numero', { articleId });
    return response.data;
  },

  // Créer un mouvement de stock
  createMouvement: async (numeroLot, mouvementData) => {
    const response = await axiosInstance.post(`/api/lots/${numeroLot}/mouvements`, mouvementData);
    return response.data;
  },

  // Obtenir l'historique des mouvements d'un lot
  getHistoriqueMouvements: async (numeroLot) => {
    const response = await axiosInstance.get(`/api/lots/${numeroLot}/mouvements`);
    return response.data;
  },

  // Obtenir les lots par article
  getByArticle: async (articleId) => {
    const response = await axiosInstance.get(`/api/lots/article/${articleId}`);
    return response.data;
  },

  // Obtenir les lots expirés ou expirant bientôt
  getLotsExpiration: async (days = 30) => {
    const response = await axiosInstance.get(`/api/lots/expiration`, { 
      params: { days } 
    });
    return response.data;
  },

  // Obtenir les lots par emplacement
  getByEmplacement: async (emplacement) => {
    const response = await axiosInstance.get(`/api/lots/emplacement`, { 
      params: { emplacement } 
    });
    return response.data;
  },

  // Recherche avancée de lots
  search: async (criteria) => {
    const response = await axiosInstance.post('/api/lots/search', criteria);
    return response.data;
  },

  // Générer un rapport PDF des lots
  generateReport: async (filters) => {
    const response = await axiosInstance.post('/api/lots/report', filters, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Exporter les lots vers Excel
  exportToExcel: async (filters) => {
    const response = await axiosInstance.post('/api/lots/export', filters, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Obtenir les statistiques des lots
  getStatistics: async () => {
    const response = await axiosInstance.get('/api/lots/statistics');
    return response.data;
  },

  // Vérifier la disponibilité d'un numéro de lot
  checkNumeroLotAvailability: async (numeroLot) => {
    const response = await axiosInstance.get(`/api/lots/check-numero/${numeroLot}`);
    return response.data;
  },

  // Transférer un lot vers un autre emplacement
  transfert: async (numeroLot, nouvelEmplacement, motif) => {
    const response = await axiosInstance.post(`/api/lots/${numeroLot}/transfert`, {
      nouvelEmplacement,
      motif
    });
    return response.data;
  }
};

export default lotService;
